import React, { useCallback } from 'react';
import { LabelRenderer } from './utils';
import { Link } from 'react-router-dom';
import { Routes } from 'routes';
import { updateEnrollmentProgress } from 'common/api/crm/organization/enrollment';
import { ProgressState } from 'common/api/crm/enums/ProgressState';

export interface CreateOrganizationFieldProps {
    editMode: boolean;
}

export const CreateOrganizationField = (props: CreateOrganizationFieldProps) => {
    const onClick = useCallback(async () => {
        // sets the orgEnrollmentLog to redirect to the OrgCreation Step
        await updateEnrollmentProgress({
            state: ProgressState.EnrollmentStartedExistingAccount,
            version: 1,
        });
    }, []);

    const getOpacity = () => (props.editMode ? 'opacity-20' : 'opacity-100');

    return (
        <div className={`flex flex-col mt-8 mb-4 ${getOpacity()}`}>
            <LabelRenderer label="Interested in starting your own organization?" />
            <Link to={`${Routes.StartProgramContinue}?newOrgEnrollment=true`} onClick={onClick}>
                Start new program
            </Link>
        </div>
    );
};
